export default __webpack_public_path__ + "static/media/yuri-lenon.4b0a9278.jpg";